var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"receipt-item-chip"},[_c('v-chip',{attrs:{"disabled":""}},[_c('v-avatar',{staticClass:"white--text",attrs:{"color":"green"}},[_vm._v(_vm._s(_vm.year))]),_c('div',{staticClass:"detail"},[_vm._v(_vm._s(_vm.text))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }